import setUpTheme from '@/fabrics/theme.js'

const CORE_THEMES_MODE = ['light', 'dark']

export default {
  install(app) {
    const theme = setUpTheme()
    app.provide('theme', theme)
  }
}

export function setCoreTheme(themeMode) {
  const element = document.querySelector('.talent')
  const currentMode = CORE_THEMES_MODE.find((item) => item.includes(themeMode))
  if (currentMode) {
    element.classList.remove(...CORE_THEMES_MODE)
    element.classList.add(currentMode)
  }
}
